// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__B76RL","bgLight":"Card_bgLight__q-sus","bgDark":"Card_bgDark__1F5wr"};